export default __webpack_public_path__ + "static/media/18.0a69c1c6.gif";